import Location from "../../PersonalInformation/CurrentLocation";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export function CurrentLocation({}) {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();

  return (
    <fieldset>
      <legend>{t("Current Location")}</legend>
      <Location
        setCurrentLocation={setSearchObject}
        currentLocation={searchObject}
      />
    </fieldset>
  );
}
